import api from 'api/client';
import { Activity, CbtActivityType, IMeeting, CheckIn, FormInput } from 'types';
import { getCbtPrograms } from 'api/cbt';

export interface GetUserActivityResponse {
  date: number;
  cbtActivity: Activity | null;
  chatActivity: Activity | null;
  dailyCheckIn: CheckIn | null;
  videoCall: IMeeting | null;
  therapyCall: IMeeting | null;
}
export const getUserActivity = async (
  userId: string,
  monthOffset: number = 1
) => {
  const response = await api
    .get(`activity/${userId}`, { searchParams: { monthOffset } })
    .json<GetUserActivityResponse[]>();
  return response;
};

export interface GetUserCbtActivityResponse {
  data: CbtActivityType[];
}

export const getUserCbtActivity = (userId: string) => {
  const cbtActivityPromise = api
    .get(`activity/cbt/all/${userId}`)
    .json<GetUserCbtActivityResponse>();

  return Promise.all([cbtActivityPromise, getCbtPrograms()]);
};

export const fetchLessonAnswers = async ({
  documentId,
  lessonSlug,
}: {
  documentId: string;
  lessonSlug: string;
}) => {
  const url = `stats/lessonAnswers/${documentId}/${lessonSlug}`;

  return await api.get(url).json<FormInput[]>();
};
